module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.af7ae50.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 370
// module chunks = 4